module.exports = __webpack_public_path__ + "img/Malaysia-5.c91d32df.jpg";